import { AUTH_USER_TOKEN_KEY } from 'constants/auth'

const isProductionEnv = (): boolean => {
  return process.env.REACT_APP_NODE_ENV === 'production'
}

export const saveAuthDetailsInCookies = (cognitoToken: string) => {
  const securedAndDomain = isProductionEnv()
    ? 'domain=hapoel.co.il; SameSite=None; Secure'
    : ''

  const expires = new Date()
  expires.setTime(expires.getTime() + 24 * 60 * 60 * 1000) // 1 day

  document.cookie = `${AUTH_USER_TOKEN_KEY}=${cognitoToken}; path=/; expires=${expires.toUTCString()}; ${securedAndDomain}`
}

export const clearAuthCookies = () => {
  const domain = isProductionEnv() ? 'domain=hapoel.co.il; ' : ''
  document.cookie = `${AUTH_USER_TOKEN_KEY}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC; ${domain}`
}
